import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { PuntoInspeccionService } from '../puntoinspeccion.service';
import { PuntoInspeccionItemViewModel } from '../puntoinspeccion.types';
import { ViewChild } from '@angular/core';
import { PorcentajeSemanalListEditComponent } from '../porcentajesemanal-list-edit/porcentajesemanal-list-edit.component';

@Component({
    selector: 'app-porcentajesemanal-wrapper-list-edit',
    templateUrl: './porcentajesemanal-wrapper-list-edit.component.html',
})
export class PorcentajeSemanalWrapperListEditComponent extends ComponentBase implements OnInit {
    visibilitySpinner = false;
    searching = false;
    saving = false;
    listPuntoInspeccion: PuntoInspeccionItemViewModel[] = [];
    originalData: PuntoInspeccionItemViewModel[] = []; // Copia original de los datos
    edition = false;
    porcentajeTotalEsValido = false;

    @ViewChild(PorcentajeSemanalListEditComponent) listEditComponent: PorcentajeSemanalListEditComponent;

    private successMessage = 'Porcentajes guardados correctamente';

    private route = 'mantenimiento/general/puntosinspeccion';

    constructor(
        protected notificacionService: NotificationService,
        private confirmationService: ConfirmationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private globalService: GlobalService,
        private pifService: PuntoInspeccionService,
        private router: Router,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit(): void {
        this.onSearch();
    }

    onSearch(): void {
        this.pifService.getListPorcentaje().subscribe((results: PuntoInspeccionItemViewModel[]) => {
            this.listPuntoInspeccion = Array.isArray(results) ? [...results] : [];
            this.originalData = JSON.parse(JSON.stringify(this.listPuntoInspeccion)); // Copia inicial
            this.searching = true;
        });
    }

    onBack(): void {
        this.router.navigate([this.route]);
    }

    tieneCamposVacios(): boolean {
        return this.listPuntoInspeccion.some(
            item =>
                item.PorcentajeSemanal === null ||
                item.PorcentajeSemanal === undefined ||
                //item.NumeroInspectores === null || //TODO: agoldero comentado hasta que lo soliciten
                //item.NumeroInspectores === undefined ||
                item.FinesDeSemana === null ||
                item.FinesDeSemana === undefined,
        );
    }

    onSave(): void {
        this.saving = true;
        const algunaVacia = this.listPuntoInspeccion.some(item => item.PorcentajeSemanal === null || item.PorcentajeSemanal === undefined);

        if (algunaVacia) {
            this.addErrorMessage('Todos los campos Porcentaje Semanal deben estar completos.');
            this.saving = false;
            return;
        }

        if (!this.listEditComponent?.isPorcentajeTotalValido()) {
            this.addErrorMessage('El porcentaje total debe ser exactamente 100%.');
            this.saving = false;
            return;
        }

        // Filtrar registros modificados
        const modifiedRows = this.listPuntoInspeccion.filter(item => {
            const originalItem = this.originalData.find(orig => orig.Id === item.Id);
            return (
                originalItem &&
                (item.PorcentajeSemanal !== originalItem.PorcentajeSemanal ||
                    /*  item.NumeroInspectores !== originalItem.NumeroInspectores ||*/ //TODO: agoldero comentado hasta que lo soliciten
                    item.FinesDeSemana !== originalItem.FinesDeSemana)
            );
        });

        // Ejemplo: Enviar los datos modificados al servicio
        this.pifService.updatePorcentajes(modifiedRows).subscribe({
            next: () => {
                this.originalData = JSON.parse(JSON.stringify(this.listPuntoInspeccion)); // Actualizar copia original
                this.addSuccessMessage(this.successMessage);
                this.onBack();
                this.saving = false;
            },
        });
    }
}
